import React from 'react';
import { VehicleDataForm } from '../../../app/models/Vehicle';
import VehicleForm from './forms/VehicleForm';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';

interface Props {
    vehicle: VehicleDataForm;
    setVehicle: (vehicle: VehicleDataForm) => void;
    fetching: boolean;
    action: () => void;
    cancel: () => void;
    errorFields?: any;
}

const VehicleFormContainer = ({
    vehicle,
    setVehicle,
    fetching,
    action,
    cancel,
    errorFields
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <VehicleForm vehicle={vehicle} setVehicle={setVehicle} errorFields={errorFields} />
                </div>
            </div>

            <hr />

            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default VehicleFormContainer;
